import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import { StandardFonts, PDFDocument } from "pdf-lib";
import fileDownload from "js-file-download";

import { formatDate } from "./date-utils";

import GradingSheetDocx from "../assets/docs/DYKA_testi_hindamisleht.docx";
import GradingSheetPdf from "../assets/docs/DYKA_testi_hindamisleht.pdf";
import InstructionsDocx from "../assets/docs/DYKA_testi_juhend.docx";
import InstructionsPdf from "../assets/docs/DYKA_testi_juhend.pdf";

export const downloadResultsFile = async (words: string[], userCode: string, startedDate: Date) => {
  const pdfDoc = await PDFDocument.create();
  const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);
  const page = pdfDoc.addPage();

  const headerText = `Kood: ${userCode}\nKuupäev: ${formatDate(startedDate, ".")}`;
  page.drawText(headerText, { x: 60, y: 800, font: font, size: 24, lineHeight: 24 });

  let wordsTextFirstHalf = "";
  let wordsTextSecondHalf = "";
  for (let i = 0; i < words.length; i++) {
    if (i < 25) wordsTextFirstHalf += `${i + 1}\t${words[i]}\n`;
    else wordsTextSecondHalf += `${i + 1}\t${words[i]}\n`;
  }

  page.drawText(wordsTextFirstHalf, { x: 60, y: 720, font: font, size: 24, lineHeight: 28 });
  page.drawText(wordsTextSecondHalf, { x: 400, y: 720, font: font, size: 24, lineHeight: 28 });

  const bytes = await pdfDoc.save();
  const file = new Blob([bytes], { type: "application/pdf" });

  fileDownload(file, `düsartria_sõnad-${userCode}-${formatDate(startedDate, "-")}.pdf`);
};

export const downloadGradingSheetFileDocx = (userCode: string, date: Date) => {
  fetch(GradingSheetDocx)
    .then((r) => r.arrayBuffer())
    .then((content) => {
      const zip = new PizZip(content);
      const doc = new Docxtemplater(zip);

      doc.setData({
        userCode: userCode,
        creationDate: formatDate(date, "."),
      });

      doc.render();

      const out = doc.getZip().generate({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      fileDownload(out, `DYKA_testi_hindamisleht_${userCode}_${formatDate(date, "_")}.docx`);
    });
};

export const downloadGradingSheetFilePdf = (userCode: string, date: Date) => {
  fetch(GradingSheetPdf)
    .then((r) => r.arrayBuffer())
    .then(async (content) => {
      const pdfDoc = await PDFDocument.load(content);

      const form = pdfDoc.getForm();

      const codeField = form.getTextField("Tinglik kood või nimi");
      const dateField = form.getTextField("Kuupäev");

      codeField.setText(userCode);
      dateField.setText(formatDate(date, "."));

      const bytes = await pdfDoc.save();
      const file = new Blob([bytes], { type: "application/pdf" });

      fileDownload(file, `DYKA_testi_hindamisleht_${userCode}_${formatDate(date, "_")}.pdf`);
    });
};

export const downloadInstructionsFileDocx = () => {
  fetch(InstructionsDocx)
    .then((r) => r.arrayBuffer())
    .then((content) => {
      const file = new Blob([content], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      fileDownload(file, "DYKA_testi_juhend.docx");
    });
};

export const downloadInstructionsFilePdf = () => {
  fetch(InstructionsPdf)
    .then((r) => r.arrayBuffer())
    .then((content) => {
      const file = new Blob([content], { type: "application/pdf" });

      fileDownload(file, "DYKA_testi_juhend.pdf");
    });
};

export const downloadVoiceRecordingFileMp3 = (
  userCode: string,
  startedDate: Date,
  buffer: Array<Uint8Array>,
  blob: Blob
) => {
  const file = new Blob(buffer, { type: blob.type });

  fileDownload(file, `düsartria_salvestus-${userCode}-${formatDate(startedDate, "-")}.mp3`);
};
